/*
 * @forgerock/javascript-sdk
 *
 * enums.ts
 *
 * Copyright (c) 2020 ForgeRock. All rights reserved.
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file for details.
 */
/**
 * Specifies the type of OAuth flow to invoke.
 */
var ResponseType;
(function (ResponseType) {
    ResponseType["Code"] = "code";
    ResponseType["Token"] = "token";
})(ResponseType || (ResponseType = {}));
export { ResponseType };
//# sourceMappingURL=enums.js.map